import { sub } from "date-fns";
import "./welcome.scss";

interface PageHeadingProps {
  title: string;
  subTitle?: string;
  className?: string;
}

export default function PageHeading({
  title,
  subTitle,
  className,
}: PageHeadingProps) {
  return (
    <div className={`page-heading ${className || ""}`}>
      <h1 className="page-heading-title">{title}</h1>
      {subTitle && <div className="page-heading-subtile">{subTitle}</div>}
    </div>
  );
}
